import {
    SET_SETTINGS,
} from "@actions/actionTypes";


export function setSettings(settings) {
    return dispatch => {
        dispatch({type: SET_SETTINGS, settings});
    }
}